import { Offcanvas } from "bootstrap";
import { forwardRef, Fragment, isValidElement, useEffect, useRef, useState } from "react";
import { isValidArray } from "../../Layout/Common/common";
import { FacetFilterMobileLite } from "./facetFilterMobile";
import { FacetFilterLite } from "./facetFilter";
import { useClearRefinements, useCurrentRefinements } from "react-instantsearch";
import { CustomHierarchicalMenu } from "./customHierarchicalMenu";

// forwardRef, not a `ref` prop: on React 18 React strips `ref` before it reaches props, so the
// destructured version silently received undefined and the category menu below never got the ref.
export const FilterContainerMobileLite = forwardRef(({ filterItems }, ref) => {
  const { items } = useCurrentRefinements();
  const { refine } = useClearRefinements();
  const offcanvasRef = useRef(null);
  const modalInstance = useRef(null);
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [filters, setFilters] = useState(null);
  const [attributeCount, setAttributeCount] = useState(null);
  const [itemCount, setItemCount] = useState(null);
  const [categoryFilterChange, setCategoryFilterChange] = useState(null);
  useEffect(() => {
    if (offcanvasRef.current) {
      modalInstance.current = new Offcanvas(offcanvasRef.current, {
        backdrop: true,
        scroll: true,
      });
    }
  }, []);

  useEffect(() => {
    if (isValidArray(items)) {
      const _catefilterItem = items.filter((f) => f.attribute.includes("categories."));
      const categoryValue = _catefilterItem[0]?.refinements[0]?.value;
      setCategoryFilterChange(categoryValue);
      const _filterItem = items.filter((f) => !f.attribute.includes("categories."));
      const totalItemCount = _filterItem.reduce((sum, f) => sum + f.refinements.length, 0);
      const totalAttrCount = _filterItem.length;
      setAttributeCount(totalAttrCount > 0 ? totalAttrCount : null);
      setItemCount(totalItemCount > 0 ? totalItemCount : null);
    } else {
      setAttributeCount(null);
      setItemCount(null);
    }
  }, [items]);

  useEffect(() => {
    handleHide();
  }, [categoryFilterChange]);

  const handleShow = () => {
    modalInstance.current?.show();
  };

  const handleHide = () => {
    modalInstance.current?.hide();
  };
  useEffect(() => {
    setFilters(filterItems);
  }, [filterItems]);

  const clearAll = () => {
    refine();
    handleHide();
  };

  return (
    <Fragment>
      <div
        className="filterbtn-left"
        data-bs-toggle="offcanvas"
        data-bs-target="#mobFilterCanvas"
        aria-controls="offcanvasRight"
      >
        <button className="btn" id="searchFilter-btn" onClick={handleShow}>
          <span className="wes-searchfilter" /> Filters {itemCount && <span className="filterCount">{itemCount}</span>}
        </button>
      </div>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="mobFilterCanvas"
        ref={offcanvasRef}
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <i className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" onClick={handleHide} />
          <h5 id="offcanvasRightLabel">Filters {attributeCount && <span>({attributeCount})</span>}</h5>
          <p className="fs-13 text-decoration-underline" onClick={clearAll}>
            Clear All
          </p>
        </div>
        <div className="offcanvas-body offcanvas-filterBody">
          <div className="accordion filters-accordion accordion-flush" id="facetFilterMobile">
            <CustomHierarchicalMenu ref={ref} />
            <FacetFilterLite attribute={`prodSpecs.manufacturer`} limit={20} showMore={true} sortBy={["count:desc"]} />
            {isValidArray(filters) &&
              filters.map((item, index) => (
                <FacetFilterLite
                  key={item}
                  attribute={`prodSpecs.${item}`}
                  limit={20}
                  showMore={true}
                  sortBy={["count:desc"]}
                />
              ))}
          </div>
        </div>
        <div className="offcanvas-footer offcanvas-filterFooter">
          <button className="btn btn-unavailable fs-13 fw-medium mb-0" onClick={clearAll}>
            Clear Filter
          </button>
          <div className="button-effect">
            <a data-bs-dismiss="offcanvas" aria-label="Close" className="btn btn-addcart fs-13 fw-medium mb-0">
              Apply Filter {attributeCount && <span>({attributeCount})</span>}
            </a>
          </div>
        </div>
      </div>
    </Fragment>
  );
});
